"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let NAVOnlineInvoiceInterfaceSettings = class NAVOnlineInvoiceInterfaceSettings extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    companyId;
    onCompany_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("companyId");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    resource;
    async $$load_resource() {
        return this.$fn.fetch('read_nav_online_interface_setting', { parameters: { company_id: this.companyId }, asResource: true });
    }
    editor;
    async $$load_editor() {
        return this.resource.editor();
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    formName;
    change_password;
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['resource', 'editor', 'formId', 'formName', 'change_password', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                resource: null,
                editor: null,
                formId: null,
                formName: "NAVOnlineInvoiceInterfaceSettings",
                change_password: {
                    password: null,
                    verify_password: null,
                },
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
            },
        };
    }
    get payload() {
        if (this.loaded) {
            return _.extend({}, this.editor.getData(), this.change_password.password && this.change_password.verify_password ? this.change_password : null);
        }
        return null;
    }
    get document() {
        if (this.loaded) {
            return {
                title: [this.$fn.pgettext("NAVOnlineInvoiceInterfaceSettings|Title", "NAV online invoice interface configuration"),
                    this.resource.company_name,
                ],
                icon: this.$config.settings.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_5500_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_script_5506_getActionArgs_value($event) {
        this.resource.reset($event.data.response.data);
    }
    async act_1040167445267876_script_5506_getActionArgs($event) {
        return {
            value: () => this.act_1040167445267876_script_5506_getActionArgs_value($event),
        };
    }
    async evh_1040167445267876_success_5505_getWhen($event) {
        return !!$event.data.response.data;
    }
    async act_1040167445267876_emit_5508_getActionArgs($event) {
        return {
            event: "saved",
        };
    }
    async evh_1040167445267876_success_5507_getWhen($event) {
        return !!$event.data.response.data;
    }
    async act_1040167445267876_request_5504_getActionArgs($event) {
        return {
            operation: "update_nav_online_interface_setting",
            data: this.payload,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_1419464017721962_closeModal_5510_getActionArgs($event) {
        return {
            name: this.modalName,
        };
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_5500 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_5500_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_5499 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_5500,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_5499],
        });
        const act_2248226175642056_closeComponent_5502 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_5501 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_5502,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_5501],
        });
        const act_1040167445267876_script_5506 = new core_1.actions.ScriptAction({
            actionArgs: this.act_1040167445267876_script_5506_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_5505 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_script_5506,
            event: "success",
            when: this.evh_1040167445267876_success_5505_getWhen,
            displayName: "script",
        });
        const act_1040167445267876_emit_5508 = new core_1.actions.EmitAction({
            actionArgs: this.act_1040167445267876_emit_5508_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_5507 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_emit_5508,
            event: "success",
            when: this.evh_1040167445267876_success_5507_getWhen,
            displayName: "emit",
        });
        const act_1040167445267876_request_5504 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_5504_getActionArgs,
            displayName: "submit",
            events: [evh_1040167445267876_success_5505, evh_1040167445267876_success_5507],
        });
        const evh_1040167445267876_submit_5503 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_5504,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_5503],
        });
        const act_1419464017721962_closeModal_5510 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1419464017721962_closeModal_5510_getActionArgs,
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_5509 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeModal_5510,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_5509],
        });
        return {
            act_7315092382398562_closeModal_5500,
            evh_7315092382398562_close_5499,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_5502,
            evh_2248226175642056_close_5501,
            evh_2248226175642056_close,
            act_1040167445267876_script_5506,
            evh_1040167445267876_success_5505,
            act_1040167445267876_emit_5508,
            evh_1040167445267876_success_5507,
            act_1040167445267876_request_5504,
            evh_1040167445267876_submit_5503,
            evh_1040167445267876_submit,
            act_1419464017721962_closeModal_5510,
            evh_1419464017721962_clickPreventStop_5509,
            evh_1419464017721962_clickPreventStop,
            submit: act_1040167445267876_request_5504,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], NAVOnlineInvoiceInterfaceSettings.prototype, "companyId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('companyId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], NAVOnlineInvoiceInterfaceSettings.prototype, "onCompany_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], NAVOnlineInvoiceInterfaceSettings.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], NAVOnlineInvoiceInterfaceSettings.prototype, "onSize", null);
NAVOnlineInvoiceInterfaceSettings = __decorate([
    (0, vue_property_decorator_1.Component)()
], NAVOnlineInvoiceInterfaceSettings);
exports.default = NAVOnlineInvoiceInterfaceSettings;
vue_property_decorator_1.Vue.component("NAVOnlineInvoiceInterfaceSettings", NAVOnlineInvoiceInterfaceSettings);
